import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { removeCookies } from '../../../utility/Cookies'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorCorrectionCreate = () => {
  const { t } = useTranslation()
  const correctionCreate = useCallback(
    (payload, loading, uid) => {
      ApiService.jsonRequest('/transaction-correction-header/create', payload, (response) => {
        let res_correction = response.messages

        if (response.status_code === 200) {
          removeCookies('summary-header')
          showAlert({
            icon: 'success',
            message: t('response_message.correction_success'),
            timer: 2000,
            redirect: uid ? `/order/correction/${uid}` : ``,
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t(`response_message.${res_correction}`),
          })
        }
        loading(false)
      })
    },
    [t],
  )
  return { correctionCreate }
}

export default InteractorCorrectionCreate
